import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesOrders } from "../../constants";
import { Order } from "../../orders.types";

export const requestGetOrders = async (
  params: GetListRequestParams
): Promise<GetListResponse<Order>> => {
  return await instance.get(ApiRoutesOrders.AllOrders, { params });
};
